import { render, staticRenderFns } from "./pageUrl.vue?vue&type=template&id=17501586&scoped=true&"
import script from "./pageUrl.vue?vue&type=script&lang=js&"
export * from "./pageUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17501586",
  null
  
)

export default component.exports